import { render, staticRenderFns } from "./frontNosotros.vue?vue&type=template&id=78a7e3f9&"
import script from "./frontNosotros.vue?vue&type=script&lang=js&"
export * from "./frontNosotros.vue?vue&type=script&lang=js&"
import style0 from "./frontNosotros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports